import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import GlobalStyles from '~/components/common/GlobalStyles';
import './i18next';

const root = ReactDOM.createRoot(window.document.getElementById('root')!);
root.render(
  <GlobalStyles>
    <App />
  </GlobalStyles>
);
